import React from 'react';
//import SavedTradePlanConfigsObservable from '../../../../znotusedcurrently/rxjs/observables/SavedTradePlanConfigsObservable.js2';
import { useState } from 'react';
import SetDefaultValuesBasedOnStoredTpConfig from '../AddTradePlan/SetDefaultValuesBasedOnStoredConfig.js';
import { useEffect } from 'react';
import { Typography, FormControl, TextField } from '@material-ui/core';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { observer } from 'mobx-react-lite';
import { useWebsocketStore } from '../../../../stores/websocketStore/websocketProvider';

const SelectSavedTradePlanConfig = observer(
  ({
    packageOfSetters,
    mutableSymbol,
    savedConfigurations,
    setSelectedSavedConfig,
    updatedSavedTp,
    setUpdatedSavedTp,
    defaultSavedConfigKey,
    focusRef,
    savedConfigChanged,
    setSavedConfigChanged,
  }) => {
    const { savedTradePlanTemplatesStore } =
      useWebsocketStore();
    const templates = savedTradePlanTemplatesStore.savedTemplates;

    return (
      <RenderTradePlanOptions
        values={templates}
        packageOfSetters={packageOfSetters}
        mutableSymbol={mutableSymbol}
        savedConfigurations={savedConfigurations}
        setSelectedSavedConfig={setSelectedSavedConfig}
        updatedSavedTp={updatedSavedTp}
        setUpdatedSavedTp={setUpdatedSavedTp}
        defaultSavedConfigKey={defaultSavedConfigKey}
        focusRef={focusRef}
        savedConfigChanged={savedConfigChanged}
        setSavedConfigChanged={setSavedConfigChanged}
      />
    );
  }
);

export default SelectSavedTradePlanConfig;
/*
export default class SelectSavedTradePlanConfig extends React.Component {
    constructor(props) {
        super(props);
        this.observable = SavedTradePlanConfigsObservable;
        this.component = RenderTradePlanOptions;
        this.state = {storedValues: {}};
    }

    componentDidMount() {
        this.subscription = this.observable.subscribe((value) =>
            this.setState({storedValues: value})
        );
    }

    componentWillUnmount() {
        this.subscription.unsubscribe();
    }

    render() {
        const Component = this.component;
        return (
            <Component
                values={this.state.storedValues}
                packageOfSetters={this.props.packageOfSetters}
                mutableSymbol={this.props.mutableSymbol}
                savedConfigurations={this.props.savedConfigurations}
                setSelectedSavedConfig={this.props.setSelectedSavedConfig}
                updatedSavedTp={this.props.updatedSavedTp}
                setUpdatedSavedTp={this.props.setUpdatedSavedTp}
                defaultSavedConfigKey={this.props.defaultSavedConfigKey}
                focusRef={this.props.focusRef}
                savedConfigChanged={this.props.savedConfigChanged}
                setSavedConfigChanged={this.props.setSavedConfigChanged}
            />
        );
    }
}*/
const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 180,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  input: {
    fontSize: 10,
  },
}));

function RenderTradePlanOptions({
  packageOfSetters,
  values,
  mutableSymbol,
  savedConfigurations,
  setSelectedSavedConfig,
  updatedSavedTp,
  setUpdatedSavedTp,
  defaultSavedConfigKey,
  focusRef,
  savedConfigChanged,
  setSavedConfigChanged,
}) {
  const classes = useStyles();
  const [id, setId] = useState(0);

  useEffect(() => {
    if (updatedSavedTp) {
      setId(0);
      setUpdatedSavedTp(false);
    }
  }, [updatedSavedTp]);

  savedConfigurations.current = values;

  const savedConfigs = savedConfigurations.current;
  const options = [];

  for (const id in savedConfigs) {
    if (savedConfigs.hasOwnProperty(id)) {
      options.push({
        configurationName: savedConfigs[id].configurationName,
        key: id,
      });

      //  if (id === defaultSavedConfigKey) {
      //  defaultConfig = {
      //  configurationName: savedConfigs[id].configurationName,
      //         key: id,
      //};
      //}
      //}
    }
  }
  const selectConfig = (id) => {
    setId(id);
    const savedConfig = savedConfigs[id];
    if (savedConfig === undefined) {
      return;
    }
    const [setStoredConfigKey, setConfigName] = packageOfSetters;
    setStoredConfigKey(savedConfig.key);
    setConfigName(savedConfig.configurationName);
    setSelectedSavedConfig(true);
    SetDefaultValuesBasedOnStoredTpConfig(
      packageOfSetters,
      savedConfig.tradePlanJson,
      mutableSymbol
    );
  };
  return (
    <>
      <FormControl
        aria-label="saved tps"
        className={classes.formControl}
        style={{ width: '100%' }}
      >
        <Autocomplete
          autoComplete
          options={options}
          getOptionLabel={(option) => option.configurationName}
          classes={{ input: classes.input }}
          renderInput={(params) => {
            if (savedConfigs[id] != undefined && savedConfigChanged) {
              params.InputProps.startAdornment = (
                <Typography style={{ fontSize: 8, color: 'red' }}>
                  edited:
                </Typography>
              );
            }
            return (
              <TextField
                {...params}
                inputRef={focusRef}
                label={
                  <Typography style={{ fontSize: 9 }}>
                    saved configurations
                  </Typography>
                }
                variant="outlined"
                onBlur={(ev, value) => {
                  let title = ev.target.value;
                  options.forEach((o) => {
                    if (o.configurationName === title) {
                      selectConfig(o.key);
                      return;
                    }
                  });
                }}
                S
              />
            );
          }}
          onChange={(ev, value) => {
            if (value === null || value === undefined) {
              return;
            }
            selectConfig(value.key);
            if (setSavedConfigChanged !== undefined) {
              setSavedConfigChanged(false);
            }
          }}
          value={savedConfigs[id] === undefined ? null : savedConfigs[id]}
        />
      </FormControl>
    </>
  );
}
